import React from "react";

import {
  GRID_ANIMATED_PATH_PROPS,
  ICON_CIRCLE_SVG_PROPS,
  ICON_SVG_GROUP_PROPS,
  ICON_SVG_PROPS,
} from "./_USER_NETWORK_GRID.config";

export function SvgFragmentIcons1() {
  return (
    <>
      <g data-motion-group={1}>
        <g data-name="iconUser" {...ICON_SVG_GROUP_PROPS}>
          <circle
            cx={1481.734}
            cy={113.715}
            r={29.01}
            {...ICON_CIRCLE_SVG_PROPS}
          />
          <path
            d="M1481.72 113.28a5.915 5.915 0 0 0 3.268-.971 5.84 5.84 0 0 0 2.175-2.602 5.792 5.792 0 0 0 .339-3.353 5.815 5.815 0 0 0-1.608-2.975 5.925 5.925 0 0 0-6.406-1.263 5.849 5.849 0 0 0-2.64 2.137 5.745 5.745 0 0 0 .725 7.323 5.913 5.913 0 0 0 4.146 1.704Zm0-8.918a3.166 3.166 0 0 1 2.942 1.926 3.098 3.098 0 0 1-.69 3.416 3.175 3.175 0 0 1-1.62.857c-.62.12-1.258.056-1.838-.182a3.162 3.162 0 0 1-1.421-1.158 3.104 3.104 0 0 1-.529-1.743c0-.826.333-1.618.925-2.203a3.175 3.175 0 0 1 2.23-.913Zm7.293 9.8v2.674c.58.004 1.136.233 1.547.635.399.403.64.949.64 1.518v1.86c0 .59-.241 1.159-.664 1.578a2.282 2.282 0 0 1-1.596.654h-14.438a2.28 2.28 0 0 1-1.6-.654 2.226 2.226 0 0 1-.662-1.579v-1.859a2.163 2.163 0 0 1 .676-1.542 2.22 2.22 0 0 1 1.586-.61l-.081-2.674a4.912 4.912 0 0 0-3.457 1.414c-.454.447-.814.98-1.06 1.565s-.371 1.214-.371 1.847v1.86a4.892 4.892 0 0 0 1.459 3.465 5.022 5.022 0 0 0 3.51 1.44h14.438a5.006 5.006 0 0 0 3.506-1.44 4.881 4.881 0 0 0 1.462-3.466v-1.859c0-1.28-.52-2.508-1.438-3.412a4.887 4.887 0 0 0-3.457-1.414Z"
            {...ICON_SVG_PROPS}
          />
        </g>
        <path
          data-name="dottedPathTopRight"
          d="m1452.72368,113.71496l-230.037.00008,230.037-.00008Z"
          {...GRID_ANIMATED_PATH_PROPS}
        />
        <path
          d="m1510.74369,113.715h230.037-230.037Z"
          data-name="dottedPathTopLeft"
          {...GRID_ANIMATED_PATH_PROPS}
        />
      </g>

      <g data-name="iconEcommerce" {...ICON_SVG_GROUP_PROPS}>
        <circle
          cx={2160.607}
          cy={358.419}
          r={29.01}
          {...ICON_CIRCLE_SVG_PROPS}
        />
        <path
          d="M2167.345 340.665h-14.203a4.44 4.44 0 0 0-4.439 4.439v26.63a4.438 4.438 0 0 0 4.439 4.439h14.203a4.434 4.434 0 0 0 3.138-1.301 4.434 4.434 0 0 0 1.3-3.138v-26.63a4.437 4.437 0 0 0-4.438-4.439Zm2.663 31.07a2.666 2.666 0 0 1-2.663 2.663h-14.203a2.662 2.662 0 0 1-2.663-2.664v-26.63a2.664 2.664 0 0 1 2.663-2.663h1.774a1.774 1.774 0 0 0 1.776 1.775h7.102a1.777 1.777 0 0 0 1.775-1.775h1.776a2.666 2.666 0 0 1 2.663 2.663v26.63Zm-7.555-12.428a2.669 2.669 0 0 0 2.566-1.935l1.731-6.055h-14.496v1.776h2.778l.657 4.563-1.597 3.985a.89.89 0 0 0 .824 1.216h10.653v-1.776h-9.339l.711-1.774h5.512Zm1.935-6.214-1.083 3.79a.883.883 0 0 1-.887.648h-4.953l-.64-4.438h7.563Zm-9.027 12.427a1.332 1.332 0 1 0 .002 2.663 1.332 1.332 0 0 0-.002-2.663Zm8.876 0a1.337 1.337 0 0 0-1.23.822 1.332 1.332 0 1 0 1.23-.822Z"
          {...ICON_SVG_PROPS}
        />
      </g>

      <g data-name="logoRevolut" {...ICON_SVG_GROUP_PROPS}>
        <circle
          cx={2808.527}
          cy={114.632}
          r={29.01}
          {...ICON_CIRCLE_SVG_PROPS}
        />
        <g>
          <path
            {...ICON_SVG_PROPS}
            d="M2808.984 106.045h-1.45c-.145.61-.181 1.174-.278 1.783l-1.04 6.335h1.79c2.296 0 3.988-1.877 3.988-4.787 0-2.017-1.172-3.33-3.01-3.33Z"
            color="#000000"
          />
          <path
            {...ICON_SVG_PROPS}
            d="M2817.76 116.931c5.5-4.082 4.509-8.727 4.509-8.727-.423-5.584-5.162-9.338-11.967-9.338 0 0-8.304.328-9.803.657-1.789.376-3.01 2.017-2.865 3.801 0 1.22-.048 2.534-.326 3.895l-2.393 15.531c-.194.892-.653 3.707 1.124 5.819.7.845 2.018 1.83 4.315 1.83 1.04 0 3.856-.141 6.153-1.174a3.859 3.859 0 0 0 1.498-1.22c1.221 1.456 3.047 2.488 5.73 2.488 2.345 0 4.641-.61 6.709-1.642 0 0 2.018-1.456 1.172-3.566-1.837-2.675-3.856-8.354-3.856-8.354Zm-.133 9.197c-1.22.376-2.635.658-3.892.61-1.318 0-3.058-.328-4.182-3.519l-1.874-5.49h-1.874l-.846 5.208a7.472 7.472 0 0 0-.193 1.784v.14c0 .33.048.658.193.986-1.462.657-3.384.845-4.557.845-.979 0-1.873-.33-1.97-2.018 0-.469.049-.892.145-1.36l2.393-15.533c.182-1.173.327-2.392.327-3.613v-1.22c.798-.187 3.614-.516 6.14-.516h2.768c1.693-.047 3.337.329 4.884.985a9.57 9.57 0 0 1 1.172.704c.327.281.665.61.991.892a8.25 8.25 0 0 1 .98 1.69c.193.656.326 1.314.326 2.017v.61c-.23 2.863-2.055 5.209-4.871 6.71l2.526 6.71c.713 1.83 1.172 2.535 1.97 3.144-.181.141-.375.187-.556.234Z"
            color="#000000"
          />
        </g>
      </g>

      <g data-name="logoBarclays" {...ICON_SVG_GROUP_PROPS}>
        <circle
          cx={2510.527}
          cy={356.874}
          r={29.01}
          {...ICON_CIRCLE_SVG_PROPS}
        />
        <path
          d="M2509.405 339.815c-.866 0-1.07.158-1.376.474h-.356c-.663 0-1.58.106-2.293.633-.714.474-1.07 1.37-.663 2.002 0 0 .255-.369 1.121-.369h.408c1.172.158 2.038.79 1.936 2.477-.102 1.686-.713 3.583-3.21 3.583 0 0-.306 0-.663-.052-1.172-.106-1.528-.896-1.528-.896s1.019-.264 1.019-1.581c0-.896-.764-1.739-1.835-2.055a4.21 4.21 0 0 0-1.172-.158 4.66 4.66 0 0 0-3.72 1.897c-2.242 3.003-2.446 7.377-1.885 11.487.56 4.11 3.057 7.905 3.108 8.01.051.053.102.105.153.105s.051 0 .102-.052c1.07-1.107 2.14-2.582 2.548-3.584.459.37.204 1.212-.05 2.108-.256.896-.867 2.108-1.071 2.477-.204.369-.51.843-.102 1.054.051 0 .102.053.153.053.51 0 1.63-.896 2.905-2.635 1.426-2.003 2.14-3.742 2.14-3.742.102 0 .255.211.255.685 0 .527-.51 2.372-1.53 4.163-.967 1.74-1.885 2.846-2.088 3.11-.102.158 0 .21.05.316.052.052 1.835 1.739 4.383 3.161 3.007 1.687 4.332 1.95 4.332 1.95s1.324-.316 4.331-1.95c2.548-1.422 4.332-3.109 4.382-3.214.051-.053.153-.158.051-.316-.152-.264-1.07-1.318-2.089-3.11-.968-1.738-1.478-3.635-1.529-4.162 0-.527.153-.685.255-.738 0 0 .714 1.792 2.14 3.741 1.274 1.74 2.395 2.635 2.905 2.635.051 0 .102 0 .153-.053.357-.21.102-.685-.102-1.053-.204-.37-.815-1.581-1.07-2.477-.255-.896-.51-1.74 0-2.108.459 1.001 1.478 2.477 2.548 3.583q.05.053.102.053c.05 0 .102-.053.153-.105.102-.106 2.599-3.9 3.16-8.01.56-4.11.356-8.484-1.835-11.488a4.66 4.66 0 0 0-3.72-1.897c-.408 0-.816.053-1.122.158-1.12.317-1.834 1.16-1.834 2.056 0 1.317 1.02 1.58 1.02 1.58s-.358.738-1.53.896c-.203.053-.458.053-.662.053-.917 0-1.682-.316-2.395-1.317-.663-1.002-.663-3.004-.714-3.69-.05-.684-.152-2.212-.866-2.845-.713-.632-1.529-.843-2.599-.896-.05.053-.153.053-.204.053"
          {...ICON_SVG_PROPS}
          color="#00afe9"
        />
      </g>

      <g data-name="iconData" {...ICON_SVG_GROUP_PROPS}>
        <circle
          cx={1814.987}
          cy={834.767}
          r={29.01}
          {...ICON_CIRCLE_SVG_PROPS}
        />
        <path
          d="M1811.664 850.542h1.661v-4.15h-1.66v4.15Zm4.983 0h1.66V838.92h-1.66v11.623Zm-1.66-22.417a3.32 3.32 0 0 0-3.323 3.32v11.625h1.661v-11.625a1.66 1.66 0 0 1 1.661-1.66 1.662 1.662 0 0 1 1.66 1.66v4.152h1.662v-4.152a3.321 3.321 0 0 0-3.322-3.32Zm11.624 17.436h1.66v-4.983h-1.66v4.983Zm-11.625-27.467a13.229 13.229 0 0 0-9.075 3.578l1.137 1.213a11.627 11.627 0 0 1 12.568-2.17 11.61 11.61 0 0 1 5.09 4.288 11.616 11.616 0 0 1 1.905 6.376v5.879h1.66v-5.88a13.286 13.286 0 0 0-13.285-13.283Zm-13.284 13.285v14.182h1.66v-14.182a11.52 11.52 0 0 1 .913-4.525l-1.527-.648a13.113 13.113 0 0 0-1.046 5.173Zm18.98-3.421a6.586 6.586 0 0 1 .946 3.42v16.673h1.661v-16.672a8.307 8.307 0 0 0-1.187-4.284l-1.42.863Zm-13.999 3.42v2.558h1.661v-2.557a6.642 6.642 0 0 1 10.213-5.604l.888-1.403a8.31 8.31 0 0 0-8.455-.275 8.302 8.302 0 0 0-4.307 7.282Zm0 16.673h1.661v-10.793h-1.66v10.793Z"
          {...ICON_SVG_PROPS}
        />
      </g>
      <g data-motion-group={2}>
        <g data-name="logoSantander" {...ICON_SVG_GROUP_PROPS}>
          <circle
            cx={2512.618}
            cy={716.209}
            r={29.01}
            {...ICON_CIRCLE_SVG_PROPS}
          />
          <path
            d="M2530.42 723.487c0 5.337-7.968 9.645-17.804 9.645-9.834 0-17.802-4.308-17.802-9.645 0-3.838 4.1-7.137 10.074-8.697a7.572 7.572 0 0 0 1.021 4.192l5.57 9.744c.428.735.71 1.518.875 2.325l.238-.403a7.75 7.75 0 0 0 0-7.73l-4.48-7.749c-1.352-2.399-1.352-5.336.025-7.705l.239-.404c.164.807.446 1.585.875 2.326l2.607 4.499 4.076 7.068c.428.734.71 1.517.882 2.32l.232-.405a7.736 7.736 0 0 0 0-7.723l-4.456-7.73a7.75 7.75 0 0 1 0-7.73l.24-.397c.164.801.446 1.584.875 2.32l5.568 9.644a7.914 7.914 0 0 1 1.023 3.538c5.974 1.56 10.098 4.86 10.122 8.697Z"
            color="#ec0000"
            {...ICON_SVG_PROPS}
          />
        </g>
        <path
          data-name="dottedPathCurvedLeft"
          d="M2274.068 620.97c55.898 51.802 128.385 85.957 208.604 93.608"
          {...GRID_ANIMATED_PATH_PROPS}
        />
        <path
          data-name="dottedPathCurvedRight"
          d="M2540.692 716.21h230.037-230.037Z"
          {...GRID_ANIMATED_PATH_PROPS}
        />
      </g>

      <g data-name="logoLloyds" {...ICON_SVG_GROUP_PROPS}>
        <circle
          cx={2159.722}
          cy={834.818}
          r={29.01}
          {...ICON_CIRCLE_SVG_PROPS}
        />
        <path
          d="M2175.857 835.5c.653.475 1.365.83 1.365 1.602 0 .237-.297.474-.89.474-.475 0-1.009-.118-1.246-.474-.178-.237.06-.653-.06-.89-.118-.237-.414-.119-.652-.237-.237-.119-.237-.238-.415-.593-.178-.416-.771-1.068-1.483-1.78-.593-.593-1.246-.89-1.542-.89h-.475c-.534 0-.95.475-1.72.83-.534.238-.83.356-1.127.416l-.12.118h.653c.653 0 1.424-.059 2.077-.059s.949.593 1.186 1.187c.475 1.186 1.187 2.966 2.076 4.449.416.712.772 1.127.772 1.957 0 .238 0 .653-.356.653-.475 0-1.72-.534-1.72-1.068 0-.415.355-.593.355-1.008 0-.238-.415-.238-.474-.475-.297-1.305-.712-2.61-1.424-3.381-.356-.416-.415-.594-.83-.594-.178 0-.416.06-.594.12-1.008.355-2.373 1.541-4.034 2.016-.652.178-.77-.178-1.423-.06h.059c-.534.12-.95.416-1.72.653-1.009.297-2.73.416-4.153.238-1.008-.12-2.313-.356-2.847-.297-.416 1.186-1.305 2.788-2.67 3.44-.712.297-.89.772-.712 1.543.238 1.008 1.127 1.72 1.602 2.61.415.712 1.127 1.898 1.839 2.254.712.356 1.186.89 1.186 1.424 0 .237-.059.356-.296.356h-1.483c-.238 0-.356-.119-.356-.237-.178-.356-.06-.712-.356-1.068-.178-.237-.356-.178-.593-.356-.416-.415-.119-.652-.416-1.186-.89-1.483-1.305-1.78-2.076-2.848-.415-.534-.95-.83-.95-1.542 0-.89.89-1.009.89-1.899-.592.416-1.245.772-2.253.89-.12 0-.475.297-.653.475-.356.356-.475.712-.534 1.246-.119 1.186-.356 2.432-.178 3.618.178.771.356 1.009.95 1.483.415.238.89.653.89 1.187 0 .118-.06.356-.238.356h-1.602c-.119 0-.296-.119-.356-.178-.178-.297-.06-.534-.118-.89-.12-.712-.95-.712-.95-1.424 0-.237.119-.534.119-.949.06-1.008.356-2.67.06-4.627-.12-1.127 1.067-1.187 1.72-2.195.356-.593.237-.356.474-.771.238-.415.178-.771.119-1.009 0-.356-.356-1.008-.119-2.491.06-.653.416-1.305.83-1.84 0 0 0-.118-.118-.118-.652.06-.652-.118-1.008-.118s-.712.355-.772.533c-.177-.059-.296-.296-.296-.415 0-.237.06-.415.237-.652.06-.06 0-.119-.118-.119-.475 0-.95.593-1.068 1.008-.297-.059-.297-.415-.416-.415s-.237.178-.237.415c0 1.424 2.314 1.72 2.314 3.62 0 2.135-2.61 1.72-2.61 2.49 0 .12.118.297.296.357-.06.178-.296.296-.534.296-.593 0-1.008-.415-1.008-1.008 0-1.187 1.602-1.187 1.602-2.077 0-.415-.238-.533-.534-.77-1.483-1.069-2.373-2.136-2.373-3.857 0-1.898 1.305-3.322 3.025-3.322 2.492 0 2.551 2.848 4.805 3.085a4.86 4.86 0 0 1 2.788-.89c1.483 0 2.077.356 3.619.356.653 0 1.661-.178 2.907-1.008.474-.297.652-.356 1.068-.772 1.008-1.245 1.957-2.847 1.957-4.033v.059c0-.356-.06-.593-.237-.593-.534 0-1.009.474-1.542 1.008-.356.356.178.534-.594.89-.237.119-.593-.119-.89-.119-.593 0-.89-.712-.89-1.305 0-.296.238-.415.357-.712.296-.593.296-.83.593-1.423.178-.416.474-.653.474-.95 0-.118-.059-.177-.059-.296 0-.593.83-1.009.83-1.602 0-.356-.355-.474-.474-.771-.06-.237 0-.356 0-.356 0-.06.06-.06.119-.06.296 0 .415.357.712.535 0-.416-.12-.475-.12-.772 0-.118 0-.415.12-.415.177 0 .177.238.355.415.238.178.416.12.653.297.297.178.475.534.593.534.297.06.415-.356.238-.534.355 0 .711.237 1.186.237.712 0 .95.178 1.127.297.475.415.534.712 1.068.712.237 0 .415-.237.474-.297.356.238.356.89 0 1.483.12.475.83.534 1.128.771.296.238.237.356.474.475.178.119.356.06.475 0 .118.653-.356 1.187-1.009 1.246 0 .83.89 1.305 1.246 1.483a1.326 1.326 0 0 1-.95.712c.12.474.653 1.186.357 1.839-.238-.119-.593 0-.593.356 0 .415.533.593 0 .89-.238.118-.297.474.118.83.593-.119 1.127-.119 1.78-.119.415 0 .89-.118 1.305-.118.652 0 1.068.237 1.542.83 1.127 1.305 2.255 2.729 3.5 3.678"
          {...ICON_SVG_PROPS}
          color="#231f20"
        />
      </g>
      <g data-motion-group={3}>
        <g data-name="logoHsbc" {...ICON_SVG_GROUP_PROPS}>
          <circle
            cx={1125.305}
            cy={984.581}
            r={29.01}
            {...ICON_CIRCLE_SVG_PROPS}
          />
          <g>
            <path
              d="m1146.163 984.806-10.43-10.43v20.86l10.43-10.43Z"
              color="#e71d1c"
              {...ICON_SVG_PROPS}
            />
            <path
              d="m1125.305 984.806 10.429-10.43h-20.858l10.429 10.43ZM1104.445 984.806l10.43 10.43v-20.86l-10.43 10.43ZM1125.305 984.806l-10.43 10.43h20.859l-10.43-10.43Z"
              color="#e71d1c"
              {...ICON_SVG_PROPS}
            />
          </g>
        </g>
        <path
          data-name="dottedPathBottomLeft"
          d="M1096.295 984.806H866.258h230.037Z"
          {...GRID_ANIMATED_PATH_PROPS}
        />
        <path
          data-name="dottedPathBottomRight"
          d="M1372.356 929.884c-45.822 34.483-102.813 54.922-164.577 54.922h-53.464"
          {...GRID_ANIMATED_PATH_PROPS}
        />
      </g>
    </>
  );
}
